import React from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Logo from "./Logo";
import "./Header.css";
import { Button, StepConnector } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LogoutButton from "../auth/LogoutButton";
import { useAdminStatus } from "../../hooks/useAdminStatus";
import AdminViewButton from "../auth/AdminViewButton";

const Header = ({ steps, activeStep, jumpTo, furthestCompletedStep }) => {
  const theme = useTheme();
  const isAdmin = useAdminStatus();

  const styleByStepStatus = (index) => {
    let backgroundColor = "";
    let color = "";
    let boxShadow = "none";

    switch (true) {
      case index === activeStep:
        backgroundColor = theme.palette.primary.main;
        color = theme.palette.primary.contrastText;
        break;
      case index <= furthestCompletedStep.step:
        backgroundColor = theme.palette.primary.main;
        color = theme.palette.primary.contrastText;
        break;
      default:
        backgroundColor = theme.palette.secondary.main;
        color = theme.palette.secondary.contrastText;
    }

    return {
      sx: {
        backgroundColor,
        borderRadius: "50%",
        padding: "8px",
        boxSizing: "content-box",
        color,
        marginTop: "-7px",
        boxShadow,
      },
    };
  };

  const handleStepClick = (index) => {
    jumpTo(index);
  };

  return (
    <header>
      <div className="wrapper">
        <Logo color="primary" />
      </div>
      <div id="stepperWrapper" className="wrapper">
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          connector={<StepConnector />}
          sx={{ width: "100%" }}
        >
          {steps.map((step, index) => {
            return (
              <Step
                key={`stepper-${step.stepName}`}
                onClick={() => handleStepClick(index)}
              >
                <StepLabel
                  slots={{ stepIcon: step.icon }}
                  slotProps={{ stepIcon: styleByStepStatus(index) }}
                >
                  <div className="stepTextWrapper">
                    <h4
                      id={index === activeStep ? "activeStepText" : ""}
                      className="stepperText"
                      style={{
                        color: theme.palette.text.main,
                        textDecoration:
                          index === activeStep
                            ? `underline ${theme.palette.accent.main} 2px solid`
                            : "none",
                      }}
                    >
                      {step.stepName}
                    </h4>
                  </div>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </div>
      <div className="wrapper">
        {isAdmin !== null && isAdmin && (
          <AdminViewButton style={{ marginRight: "0.25em" }} />
        )}
        <LogoutButton />
      </div>
    </header>
  );
};

export default Header;
